import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './cta26.css'

const CTA26 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="thq-section-max-width">
        <div className="cta26-accent2-bg">
          <div className="cta26-accent1-bg">
            <div className="cta26-container2">
              <div className="cta26-content">
                <span className="cta26-text1 thq-heading-2">
                  {props.heading1 ?? (
                    <Fragment>
                      <span className="cta26-text3">
                        Reach out and let us help you, bridge the data &amp;
                        digital gap!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="cta26-actions">
                <Link to="/contact" className="cta26-navlink thq-button-filled">
                  <span>
                    {props.action1 ?? (
                      <Fragment>
                        <span className="cta26-text4">
                          Get in touch with us today
                        </span>
                      </Fragment>
                    )}
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CTA26.defaultProps = {
  heading1: undefined,
  action1: undefined,
}

CTA26.propTypes = {
  heading1: PropTypes.element,
  action1: PropTypes.element,
}

export default CTA26
